import { useEffect } from 'react';
import { create } from 'zustand';

interface BottomNavState {
  /** 화면이 요청해서 하단 탭바를 숨긴 상태인지 (역할별로 탭 자체가 없는 것과는 별개) */
  isHidden: boolean;
  setBottomNavHidden: (hidden: boolean) => void;
}

/** 하단 탭바 숨김 상태 — MainLayout이 읽고, 화면은 useHideBottomNav로 켜고 끈다 */
export const useBottomNavStore = create<BottomNavState>((set) => ({
  isHidden: false,
  setBottomNavHidden: (hidden) => set({ isHidden: hidden }),
}));

/**
 * 이 훅을 호출한 화면이 떠 있는 동안만 하단 탭바를 숨긴다.
 * 언마운트(다른 화면으로 이동)되면 자동으로 다시 보여준다 — 화면이 직접 true/false를 관리할 필요 없음.
 *
 * @example
 * function FullscreenPlayerPage() {
 *   useHideBottomNav();
 *   ...
 * }
 */
export function useHideBottomNav() {
  const setBottomNavHidden = useBottomNavStore((s) => s.setBottomNavHidden);

  useEffect(() => {
    setBottomNavHidden(true);
    return () => setBottomNavHidden(false);
  }, [setBottomNavHidden]);
}
